import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M8 16H1V9l8-8 7 7zm8.707-8.707-7-7a.997.997 0 0 0-1.414 0l-8 8A1 1 0 0 0 0 9v7a1 1 0 0 0 1 1h7c.265 0 .52-.105.707-.293l8-8a1 1 0 0 0 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M5 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }